import { GeoJSON } from 'geojson'
import * as z from 'zod'

const GeoJsonPointCoordinateSchema = z
  .object({
    geometry: z.object({
      type: z.literal('Point'),
      coordinates: z
        .array(z.number())
        .length(2)
        .transform(([longitude, latitude]) => ({
          lat: latitude,
          lng: longitude,
        })),
    }),
  })
  .transform(({ geometry }) => geometry.coordinates)

export const getPointCoordinates = (geoJson: GeoJSON): google.maps.LatLngLiteral | null => {
  const coord = GeoJsonPointCoordinateSchema.safeParse(geoJson)
  if (coord.success) {
    return coord.data
  } else {
    return null
  }
}
